import Fuse from 'fuse.js';

type Keys<Item extends {}> =
  | Array<keyof Item>
  | Array<{ key: keyof Item; weight: number }>;

export type Options = {
  threshold?: number;
};

export const getAutoCompleteSuggestions = <Item extends {}>(
  input: string | undefined,
  values: Item[],
  keys: Keys<Item>,
  { threshold }: Options = { threshold: 0.4 },
) => {
  if (!input) {
    return values;
  }

  const fuse = new Fuse(values, {
    keys: keys.map((key) => {
      if (typeof key === 'object' && 'key' in key && 'weight' in key) {
        return { name: key.key as string, weight: key.weight };
      }
      return key as string;
    }),
    threshold,
  });

  const result = fuse.search(input);
  return result.map(({ item }) => item);
};
